import { render } from "./MaintenanceBroadcast.vue?vue&type=template&id=06bc63b5&scoped=true&ts=true"
import script from "./MaintenanceBroadcast.vue?vue&type=script&lang=ts"
export * from "./MaintenanceBroadcast.vue?vue&type=script&lang=ts"

import "./MaintenanceBroadcast.vue?vue&type=style&index=0&id=06bc63b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bc63b5"]])

export default __exports__